import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import Select from 'containers/components/Fields/Select';
import { getLiteral } from 'utils/getLiteral';

const IntegrationCountrySelect = memo(
    ({ error, literal, mandatory, onChange, optional, value }) => {
        const placeholder = getLiteral('label_selectone');
        const label = useMemo(() => getLiteral(literal), [literal]);

        const handleChange = useCallback(
            (newValue) => {
                onChange?.(newValue ?? '');
            },
            [onChange],
        );

        return (
            <div className="mailchimp-configuration-input">
                <Select
                    className="integration-configuration-field"
                    error={error}
                    hint={placeholder}
                    isFullWidth
                    label={label}
                    labelMode="vertical"
                    list="tblCountries"
                    mandatory={mandatory && !optional}
                    placeholderReadOnly={placeholder}
                    usePlainValue
                    value={value || undefined}
                    onChange={handleChange}
                />
            </div>
        );
    },
);

IntegrationCountrySelect.displayName = 'IntegrationCountrySelect';

IntegrationCountrySelect.propTypes = {
    error: PropTypes.string,
    literal: PropTypes.string.isRequired,
    mandatory: PropTypes.bool,
    onChange: PropTypes.func,
    optional: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IntegrationCountrySelect;
